module.exports = __webpack_public_path__ + "img/mb-step-2.4535aec1.png";